import axios from "axios";
import { backendHost } from "../config";

const BASE_URL = `${backendHost}/api/v1/`;

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  if (localStorage.getItem("token")) {
    config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  }
  return config;
});

api.interceptors.response.use(
  (config) => {
    return config;
  },
  async (err) => {
    if (
      err?.response.status === 401 &&
      err.config &&
      err.config.url !== "auth/token/refresh/"
    ) {
      const originalRequest = err.config;

      if (!localStorage.getItem("token")) {
        return;
      }
      try {
        const response = await api.post(
          "auth/token/refresh/",
          {},
          {
            withCredentials: true,
          },
        );
        localStorage.setItem("token", response.data.access);
        return api.request(originalRequest);
      } catch (e) {
        localStorage.removeItem("token");
        window.dispatchEvent(new CustomEvent("tokenExpired"));
      }
    }
    return Promise.reject(err);
  },
);

export default api;
